import { Component, Input } from "@angular/core";

interface LoaderData {
  image: string;
  alt: string;
  header: string;
  message: string;
}

@Component({
  selector: "app-dynamic-loader",
  templateUrl: "./dynamic-loader.component.html",
  styleUrls: ["./dynamic-loader.component.scss"],
})
export class DynamicLoaderComponent {
  @Input() applyingLogisticLoader = false;
  @Input() applyingSKUfunnelLoader = false;
  @Input() applyingVilcOpportunityLoader = false;

  private readonly EDA_TO_NESTING_LOADER_MESSAGE =
    "This may take a few minutes.";
  private readonly VILC_OPPORTUNITY_LOADER_MESSSAGE =
    "Please wait for sometime, while we process the plan...";

  private readonly loaderMap: Record<string, LoaderData> = {
    logistic: {
      image: "/assets/images/optimization-loader.gif",
      alt: "Optimization loader",
      header: "Running PHI",
      message: this.EDA_TO_NESTING_LOADER_MESSAGE,
    },
    sku: {
      image: "/assets/images/filter-loader.gif",
      alt: "Filter loader",
      header: "Analyzing SKUs",
      message: this.EDA_TO_NESTING_LOADER_MESSAGE,
    },
    vilcOpportunity: {
      image: "/assets/images/vilc-loader.gif",
      alt: "Filter loader",
      header: "Simulating Results",
      message: this.VILC_OPPORTUNITY_LOADER_MESSSAGE,
    },
  };

  get showLoaderDialog(): boolean {
    return (
      this.applyingLogisticLoader ||
      this.applyingSKUfunnelLoader ||
      this.applyingVilcOpportunityLoader
    );
  }

  get loaderConfig(): LoaderData | null {
    if (this.applyingLogisticLoader) return this.loaderMap.logistic;
    if (this.applyingSKUfunnelLoader) return this.loaderMap.sku;
    if (this.applyingVilcOpportunityLoader)
      return this.loaderMap.vilcOpportunity;
    return null;
  }
}
